export default __webpack_public_path__ + "img/62b2f517b35b938b5eeba8d23659cbf1.svg";